import DavidAbel from '../../Images/david.jpeg';
// import marcusWilliams from './assets/marcus-williams.jpg';
// import emilyRodriguez from './assets/emily-rodriguez.jpg';
// import jamesPark from './assets/james-park.jpg';

export const team = () => {
    return [
        {
            name: "David Abdelmaseh",
            role: "RPh, PharmD\nDesignated Manager",
            image: DavidAbel
        },
        // {
        //     name: "Nounou",
        //     role: "Pharmacist",
        //     image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop"
        // },
        // {
        //     name: "John Smith",
        //     role: "Pharmacy Technician",
        //     image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
        // },
        // {
        //     name: "Lilian Zaky",
        //     role: "Pharmacy Technicianr",
        //     image: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=400&h=400&fit=crop"
        // }
    ];
}
